export default "__VITE_ASSET__CMMCRbX2__"